import { useState } from 'react';
import './settings.scss';
import AccountTab from '../settings/components/AccountSettings';
import PrivacyTab from '../settings/components/PrivacySettings';
import SecurityTab from '../settings/components/SecuritySettings';

const Settings = () => {
    const [activeTab, setActiveTab] = useState('account');

    const renderContent = () => {
        switch (activeTab) {
            case 'account':
                return <AccountTab />;
            case 'privacy':
                return <PrivacyTab />;
            case 'security':
                return <SecurityTab />;
            default:
                return <AccountTab />;
        }
    };

    return (
        <div className="settings">
            <div className="settings-wrapper">
                <div className="settings-menu">
                    <h2>
                        Settings
                    </h2>

                    <ul>
                        <li 
                            className={activeTab === 'account' ? 'active' : ''} 
                            onClick={() => setActiveTab('account')}
                        >
                            Account Info
                        </li>

                        <li 
                            className={activeTab === 'security' ? 'active' : ''} 
                            onClick={() => setActiveTab('security')}
                        >
                            Security & Password
                        </li>

                        <li 
                            className={activeTab === 'privacy' ? 'active' : ''} 
                            onClick={() => setActiveTab('privacy')}
                        >
                            Privacy
                        </li>
                    </ul>
                </div>

                <div className="settings-content">
                    {renderContent()}
                </div>

            </div>
        </div>
    );
};

export default Settings;